/* eslint-disable no-console */
import Vue from 'vue';
import axios from 'axios';
import { UseUnauthorizedProcess, UseAddAuthenticationProcess } from '@/utils/AuthorizationRequestProcessor.js';
import store from './store';
import { i18n } from './i18n';
import { modules } from './modules';

const merge = function merge(...objects) {
  const isObject = (obj) => obj && typeof obj === 'object';

  return objects.reduce((accum, current) => {
    const result = accum;
    Object.keys(current).forEach((key) => {
      const accumVal = accum[key];
      const currentVal = current[key];

      if (Array.isArray(accumVal) && Array.isArray(currentVal)) {
        result[key] = accumVal.concat(...currentVal);
      } else if (isObject(accumVal) && isObject(currentVal)) {
        result[key] = merge(accumVal, currentVal);
      } else {
        result[key] = currentVal;
      }
    });

    return result;
  }, {});
};

const storeModules = {};

const registerModules = function registerModules(items) {
  if (items) {
    Object.keys(items).forEach((key) => {
      if (storeModules[key]) {
        storeModules[key] = merge(storeModules[key], items[key]);
      } else {
        storeModules[key] = items[key];
      }
    });
  }
};

const registerLocales = function registerLocales(langs) {
  if (langs) {
    Object.keys(langs).forEach((key) => {
      const origin = i18n.getLocaleMessage(key);
      i18n.setLocaleMessage(key, merge(origin, langs[key]));
    });
  }
};

const registerFilters = function registerFilters(filters) {
  if (filters) {
    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key]);
    });
  }
};
Object.keys(modules).forEach((key) => {
  // register store module
  registerModules(modules[key].stores);
  // register locales
  registerLocales(modules[key].langs);
  // register filters
  registerFilters(modules[key].filters);
});

Object.keys(storeModules).forEach((key) => {
  store.registerModule(key, storeModules[key]);
});

UseUnauthorizedProcess(axios);
UseAddAuthenticationProcess(axios);

export { store };
export { i18n };
